<div id="sideNav" [class.visible]="slideLeft">
    <div class="backLayer" (click)="beh.showSideNav.next(false)"></div>

    <div class="navMenu">

        <ul>
            <li><a (click)="beh.showSideNav.next(false); eventRegist('HOME_CLICK')" routerLink="/" queryParamsHandling="merge" [title]="'home.home' | translate">
                <img class="icon" src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_home.svg" alt="Home Icon">{{ 'home.home' | translate }}
            </a></li>

            <li *ngIf="!!User$.id"><a (click)="beh.showSideNav.next(false); eventRegist('VOUCHER_LIST_CLICK')" routerLink="/billetera/vales" queryParamsHandling="merge" [title]="'side-nav.myVouchers.0' | translate">
                <img class="icon" src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_credits.svg" alt="Vouchers Icon">{{ 'side-nav.myVouchers.0' | translate }}
            </a></li>

            <li><a (click)="beh.showSideNav.next(false)" routerLink="/billetera/recargar" queryParamsHandling="merge" [title]="'side-nav.uparPlans' | translate">
                <img class="icon" src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_change_subs.svg" alt="Plans Icon">{{ (!UserSubscribed$ ? 'side-nav.uparPlans' : 'account.topupWallet') | translate }}
            </a></li>

            <li *ngIf="!!User$.id"><a (click)="beh.showSideNav.next(false); eventRegist('MY_PROFILE_CLICK')" routerLink="/usuario" queryParamsHandling="merge" [title]="'side-nav.myAccount' | translate">
                <img class="icon" src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_account.svg" alt="User Icon">{{ 'side-nav.myAccount' | translate }}
            </a></li>

            <li *ngIf="!!User$.id"><a (click)="beh.showSideNav.next(false); eventRegist('WALLET_CLICK')" routerLink="/billetera" queryParamsHandling="merge" [title]="'side-nav.myWallet' | translate">
                <img class="icon" src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_wallet.svg" alt="Wallet Icon">{{ 'side-nav.myWallet' | translate }}
            </a></li>

            <li><a (click)="beh.showSideNav.next(false)" routerLink="/ajustes" queryParamsHandling="merge" [title]="'side-nav.settings' | translate">
                <img class="icon" src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_settings.svg" alt="Settings Icon">{{ 'side-nav.settings' | translate }}
            </a></li>
            
            <!-- <li><a (click)="beh.showSideNav.next(false)" routerLink="/" queryParamsHandling="merge" [title]="'side-nav.whyUpar' | translate">
                <img class="icon" src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_learn.svg" alt="Learn Icon">{{ 'side-nav.whyUpar' | translate }}
            </a></li> -->

            <!-- <li class="search">
                <input #search type="text" [placeholder]="'home.searchVoucher' | translate" (keyup.enter)="gotoSearch(search.value)"><span (click)="gotoSearch(search.value)"><i class="fas fa-search"></i></span>
            </li> -->

            <li><a (click)="beh.showSideNav.next(false)" routerLink="/acerca" queryParamsHandling="merge" [title]="'global.aboutUpar' | translate">
                <img class="icon" src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_about.svg" alt="About Icon">{{ 'global.aboutUpar' | translate }}
            </a></li>

            <li><a (click)="beh.showSideNav.next(false); eventRegist('FAQ_CLICK')" routerLink="/acerca/faq" queryParamsHandling="merge" [title]="'global.portal-faq' | translate">
                <img class="icon" src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_help.svg" alt="Help Icon">{{ 'global.portal-faq' | translate }}
            </a></li>

            <li *ngIf="!!global.propConfs$?.emailContact"><a href="mailto:{{ global.propConfs$?.emailContact }}" [title]="'side-nav.contact' | translate">
                <i class="far fa-envelope"></i>{{ 'side-nav.contact' | translate }}
            </a></li>

            <li *ngIf="!!User$.id"><a (click)="loginSvc.doLogOut(); eventRegist('LOGOUT_CTA_CLICK')" [title]="'side-nav.logout' | translate">
                <img class="icon" src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_logoff.svg" alt="Signout Icon">{{ 'side-nav.logout' | translate }}
            </a></li>
        </ul>

    </div>
</div>